module.exports = "../images/logo-idc-race.png";